import { EMOTES, UI_FRAME_ART } from "@zend/content";
import type { CSSProperties, ReactNode } from "react";
import { portraitUrl, iconUrl } from "../assets/manifest.js";
import "./cosmetic-preview.css";

const frameImages: Readonly<Record<string, string>> = UI_FRAME_ART;

export function CosmeticFrame({ id, colour, avatar = "unit.cadet_01", children }: { id: string; colour: string; avatar?: string | null; children?: ReactNode }) {
  const frame = frameImages[id] ?? UI_FRAME_ART.steel;
  return <div className="cosmetic-frame" data-frame={id} style={{ "--cos-accent": colour } as CSSProperties}>
    <div className="cosmetic-frame-inner">{children ?? <img src={portraitUrl(avatar ?? "unit.cadet_01")} alt="" draggable={false} />}</div>
    <img className="cosmetic-frame-art" src={iconUrl(frame)} alt="" draggable={false} />
  </div>;
}

/** All message and picker imagery comes from the pipeline's same authored emote set. */
export function EmoteImage({ id, size = 30 }: { id: string; size?: number }) {
  if (!EMOTES.some((e) => e.id === id)) return <span>{`:${id}:`}</span>;
  return <img className="cosmetic-emote" src={iconUrl(`emote.${id}`)} srcSet={`${iconUrl(`emote.${id}`, "1x")} 1x, ${iconUrl(`emote.${id}`)} 2x`} width={size} height={size} alt={`:${id}:`} title={`:${id}:`} draggable={false} />;
}
